import React from 'react';
import { Label } from 'app/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { useFormContext } from 'react-hook-form';

function LanguageDropdown() {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const selectedLanguage = watch('language');

  const handleSelectChange = value => {
    setValue('language', value, { shouldValidate: true });
  };

  return (
    <div className="py-2">
      <Label htmlFor="language">Language</Label>
      <Select
        onValueChange={handleSelectChange}
        value={selectedLanguage}
        name="language"
      >
        <SelectTrigger id="language">
          <SelectValue placeholder="Select a language" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="english">English</SelectItem>
          <SelectItem value="spanish">Spanish</SelectItem>
          <SelectItem value="french">French</SelectItem>
          <SelectItem value="german">German</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

export default LanguageDropdown;
